<template>
  <app-regions-select :label="$t('PICKUP_REGIONS_SELECT.TITLE')"
                      :regions="pickupRegions"
                      :value="value"
                      @input="emit">
  </app-regions-select>
</template>

<script>
import facetsService from '@/services/facetsService'
import AppRegionsSelect from '../regions-select/RegionsSelect'

export default {
  name: 'AppPickupRegionsSelect',
  components: { AppRegionsSelect },
  props: {
    value: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {
    return {
      isLoading: false,
      pickupRegions: []
    }
  },
  created () {
    this.getPickupRegions()
  },
  methods: {
    async getPickupRegions () {
      this.isLoading = true

      try {
        this.pickupRegions = await facetsService.findAllPickupRegions()
      } catch (error) {
        console.error(error)
      }

      this.isLoading = false
    },
    emit (value) {
      this.$emit('input', value)
    }
  }
}
</script>
